/** Dashboard A på test, lokal utveckling och deque.se (produktion och kundportaler). */
export function isDesignPreviewHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return true;
  return host === 'deque.se' || host.endsWith('.deque.se');
}
